import React from 'react';
import styled from 'styled-components';
import { ReactComponent as LogoutIcon } from '../../assets/imgs/logout.svg';
import { CircularProgress, Tooltip } from '@mui/material';

interface ILogout {
    onLogoutClick: any;
    loading?: boolean;
    isCollapsed?: boolean;
}

const LogoutButton = styled.div<{ $loading?: boolean; $isCollapsed?: boolean }>`
  flex-direction: row;
  color: white;
  display: flex;
  padding-left: ${(props) => (props.$isCollapsed ? "0" : "20px")};
  padding-top: 6px;
  padding-bottom: 6px;
  cursor: ${props => props.$loading ? 'not-allowed' : 'pointer'}; 
  align-items: center;
  justify-content: ${(props) => (props.$isCollapsed ? "center" : "flex-start")};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #031B3026;
    font-weight: bold;
  }
`;

const Logout = ({ onLogoutClick, loading, isCollapsed }: ILogout) => {
    const buttonContent = (
        <LogoutButton 
            onClick={loading ? undefined : onLogoutClick} 
            $loading={loading}
            $isCollapsed={isCollapsed}
        >
            {loading ? (
                <CircularProgress size={20} color="inherit" style={{ marginRight: isCollapsed ? 0 : 10 }} />
            ) : (
                <LogoutIcon style={{ minWidth: 20 }} />
            )}
            {!isCollapsed && (
                <span style={{ paddingLeft: "10px", fontSize: "14px" }}>
                    Sair
                </span>
            )}
        </LogoutButton>
    );

    if (isCollapsed) {
        return (
            <Tooltip title="Sair" placement="right" arrow>
                <div>
                    {buttonContent}
                </div>
            </Tooltip>
        );
    }

    return buttonContent;
};

export default Logout;